import { Location } from "@angular/common";
import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { MenusModel } from '../../_LOS/_layout/Models/MenusModel';
import { userlayoutService } from '../../_LOS/_layout/Services/app.userlayout.Service';
import { DataSharingService } from '../../AuthGuard/DataSharingService';
import { EncrDecrService } from '../../AuthGuard/EncrDecrService';
import { MasterService } from '../../Shared/app.Masters.Service';
import { DialogService } from '../../Shared/dialog.service';
declare var $: any;

@Component({
  selector: 'app-setting-layout',
  templateUrl: './setting-layout.component.html',
  styleUrls: ['./setting-layout.component.scss']
})
export class SettingLayoutComponent implements OnInit {
  private data: any;
    token: any;
    showSpinner = false;
    activeIcon: string;
    private _userservice;
    MenusModel: MenusModel = new MenusModel();
    options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
    currentDate = new Date();
    todayDate = "";
    Menuslinks: any;
    CheckLoad: any;
    username = "";
    setAutoHide: boolean = false;
    autoHide: number = 2000;
    action: boolean = false;
    actionButtonLabel: string = 'Retry';
    show: boolean = false
    plusMinus: any = '+';
    checkIn: boolean = false;
    active: any = "";
    recentActiveCheckIn: boolean = false;
    recentActive: any = "";
    lastaccess: Date;
    currentlogin: Date;
    mysubscription: any;
    activeroute: any; dialogreturn: any;
    liveclock: any;
    FyearId: any;
    BranchId: any = 0;
    //#endregion
    BranchesList: any[] = [];
    configSuccess: MatSnackBarConfig = {
      panelClass: 'style-success',
      duration: 5000,
      horizontalPosition: 'right',
      verticalPosition: 'top'
    };
    HeaderTitle: string = '';
   FyearDropdown: any[] = [];
  MenuslinksNew: any[] = [
     {
    MM_ID: 1,
    MM_Name: "Employee Mail Template",
    MM_Url: "/confidential/employee-mail-template",
    MM_iconName: "fa fa-arrow-right",
    MM_ParentID: 0,
    MM_IsShow: true,
    MM_IsParent: false
  },
  {
    MM_ID: 2,
    MM_Name: "Employee Event Config",
    MM_Url: "/confidential/employee-event-config",
    MM_iconName: "fa fa-arrow-right",
    MM_ParentID: 0,
    MM_IsShow: true,
    MM_IsParent: false
  },

 
  {
    MM_ID: 3,
    MM_Name: "Customer Mail Template",
    MM_Url: "/confidential/email-template",
    MM_iconName: "fa fa-arrow-right",
    MM_ParentID: 0,
    MM_IsShow: true,
    MM_IsParent: false
  },

  {
    MM_ID: 4,
    MM_Name: "Customer Event Config",
    MM_Url: "/confidential/setting-product-list",
    MM_iconName: "fa fa-arrow-right",
    MM_ParentID: 0,
    MM_IsShow: true,
    MM_IsParent: false
  },
  {
    MM_ID: 5,
    MM_Name: "NOC Checking Master",
    MM_Url: "/confidential/setting-noc-product-list",
    MM_iconName: "fa fa-arrow-right",
    MM_ParentID: 0,
    MM_IsShow: true,
    MM_IsParent: false
  },
  
];

  sidemenus = [ 
    {
      MM_ID: 2,
      MM_IsParent: false,
      MM_IsShow: true,
      MM_Name: "Group Master",
      MM_ParentID: 0,
      MM_Url: "/lms-accounting/group-master",
      MM_iconName: "fa fa-users"        
    }
  ];
   constructor(private _Route: Router, public snackBar: MatSnackBar, private http: HttpClient, private _userlayoutservice: userlayoutService,
     private EncrDecr: EncrDecrService, private MasterService: MasterService, private _location: Location, private dataSharingService: DataSharingService, private router: Router, private dialog: DialogService) {
     this.data = JSON.parse(sessionStorage.getItem('currentUser'));
   }
    //#region < isLinkActive>
  public isLinkActive(url: string): boolean {
    return this._Route.url.indexOf(url) > -1;
  }

  //#endregion
 ngOnInit() {
  this.dataSharingService.getHeaderTitle().subscribe(value => {
      this.HeaderTitle = value||"Settings Dashboard";
    });
 }
  onChangeFyear(event) {
   // return this._Route.url.indexOf(url) > -1;
    console.log("event", this._Route.url);
    var Url = this._Route.url.split('?')[0];
    sessionStorage.setItem("FyearId", JSON.stringify(this.FyearId));
    //+ '? fyear=' + this.FyearId + '& BranchId=' + this.BranchId;
    this.router.navigate([Url], { queryParams: { fyear: this.FyearId, BranchId: this.BranchId } });
  }
  onChangeBranch(event) {
    var Url = this._Route.url.split('?')[0];
    //+ '? fyear=' + this.FyearId + '& BranchId=' + this.BranchId;
    this.router.navigate([Url], { queryParams: { fyear: this.FyearId, BranchId: this.BranchId } });
  }
  //#region < toggle>
  toggle() {
    this.show = !this.show;
    // CHANGE THE NAME OF THE BUTTON.
    if (this.show)
      this.plusMinus = "-";
    else
      this.plusMinus = "+";

  }
  //#endregion

  //#region < recentCheck>
  recentCheck() {
    this.active = "";
    this.checkIn = false;
    this.recentActiveCheckIn = !this.recentActiveCheckIn;
    if (this.recentActiveCheckIn) {
      this.recentActive = "recentActive";
    } else {
      this.recentActive = "";
      this._Route.navigated = true;
    }
  }
  //#endregion

  //#region < check>

  check() {
    this.recentActive = "";
    this.recentActiveCheckIn = false;
    this.checkIn = !this.checkIn;
    if (this.checkIn) {
      this.active = "active";
      //   TodaysappointmentsComponent;
    }
    else {
      this.active = "";
      //  TodaysappointmentsComponent;
    }
  }
  //#endregion

  //#region < toggleNew>
  toggleNew(currentMenu) {
    this.recentActive = "";
    this.recentActiveCheckIn = false;
    if (currentMenu.MM_IsParent == true) {
      // if show only submenu then replace this.MenuslinksNew to this.sidemenus
      this.MenuslinksNew.forEach(element => {
        if (element === currentMenu) {
          currentMenu.MM_IsShow = !currentMenu.MM_IsShow;
          //sessionStorage.setItem("CheckLoad", JSON.stringify(this.MenuslinksNew));
        } else {
          element.MM_IsShow = true;
          //sessionStorage.setItem("CheckLoad", JSON.stringify(this.MenuslinksNew));
        }
      });
    }
    this.getPageAccess(currentMenu);
  }
  //#endregion
  getPageAccess(row) {
    sessionStorage.removeItem("AllPageAcess");
    this.MasterService.Get_Page_Rights_Of_EMP({ MMID: row.MM_ID.toString(), LoginUserId : this.data.userId}).subscribe((result: any) => {
      sessionStorage.setItem("AllPageAcess", JSON.stringify(result));
    });
  }
  //#region < getStateNew>
  getStateNew(currentMenu) {
    if (!currentMenu.MM_IsShow) {

      return 'down';
    } else {
      return 'up';
    }
  }
  //#endregion

  gotoCustomerEntry() {
    this._Route.navigate(['/lms-customer']);
  }

  
}
